"use client"

import FormTextInput from "@/shared/components/form-inputs/form-text-input"
import FormPhoneInput from "@/shared/components/form-inputs/form-phone-input"
import FormSelectInput from "../../../../../shared/components/form-inputs/form-select-input"
import { servingPreferenceOptions } from "@/features/auth/constants/select-options"
import FormTextareaInput from "../../../../../shared/components/form-inputs/form-textarea-input"
import { SignupFormType } from "@/features/auth/types/signup.type"
import { useFormContext } from "react-hook-form"
import { useSignupFormContext } from "@/features/auth/hooks"
   

// TODO: Remove this phone number, only for phone number testing
// 877-406-6154
// +18774066154
// '+18786786877'
function SuceessSignupForm1() {
    const { control } = useFormContext<SignupFormType>()
    const { setValue } = useSignupFormContext()
    return (
        <div className="flex flex-col gap-5">
            <FormTextInput
                placeholder="Full Name*"
                name="form1.fullname"
                inputGroupProps={{
                    label: "Full Name *",
                }}
                control={control}
            />
            <FormTextInput
                placeholder="Email*"
                name="form1.email"
                type="email"
                inputGroupProps={{
                    label: "Email *",
                }}
                control={control}
            />
            
            <FormTextInput
                control={control}
                inputGroupProps={{
                    label: "Password",
                }}
                name="form1.password"
                type="password"
                placeholder="Password*"
            />
            <FormTextInput
                control={control}
                inputGroupProps={{
                    label: "Confirm Password",
                }}
                name="form1.confirmPassword"
                type="password"
                placeholder="Confirm Password*"
            />
        </div>

    )
}

export default SuceessSignupForm1